// Tab shell for /einstellungen. Renders the 5 tabs + Outlet for the active
// section. Deep-linkable: /einstellungen/praxis|team|nachrichten|abo|rechtliches.

import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Building2, Users, MessageSquare, CreditCard, FileText } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import SettingsPage from './SettingsPage';

const TABS = [
  { id: 'praxis',       to: '/einstellungen/praxis',       icon: Building2,    key: 'praxis' },
  { id: 'team',         to: '/einstellungen/team',         icon: Users,        key: 'team' },
  { id: 'nachrichten',  to: '/einstellungen/nachrichten',  icon: MessageSquare, key: 'nachrichten' },
  { id: 'abo',          to: '/einstellungen/abo',          icon: CreditCard,   key: 'abo' },
  { id: 'rechtliches',  to: '/einstellungen/rechtliches',  icon: FileText,     key: 'rechtliches' },
];

export default function SettingsLayout() {
  const { t } = useTranslation();
  const { user, practice } = useAuth();
  const location = useLocation();

  // Superadmin without a practice context drops to the legacy overview.
  if (!practice && user?.role === 'superadmin') {
    return <SettingsPage />;
  }

  return (
    <div data-testid="settings-layout">
      <h1 className="text-2xl font-bold tracking-tight">{t('settings.title')}</h1>
      <p className="mt-1 text-sm text-text-secondary">{t('settings.subtitle')}</p>
      <nav className="mt-5 border-b border-border flex gap-1 overflow-x-auto" data-testid="settings-tabs">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          return (
            <NavLink
              key={tab.id}
              to={tab.to}
              data-testid={`settings-tab-${tab.id}`}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-accent text-accent bg-accent/5'
                    : 'border-transparent text-text-secondary hover:text-text hover:bg-background/40'
                }`
              }
            >
              <Icon size={14}/>{t(`settings.tabs.${tab.key}`)}
            </NavLink>
          );
        })}
      </nav>
      <div className="mt-6">
        <Outlet />
      </div>
    </div>
  );
}
